var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"position-relative alert w-100 alert-dismissible",class:[
      `alert-${_vm.color}`,
      {
        'mb-6': _vm.position.includes('top'),
        'mt-6': _vm.position.includes('bottom')
      }
    ],attrs:{"role":"alert"}},[_c('pre',[_vm._v(_vm._s(_vm.message)+"\n")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"alert","aria-label":"Close"},on:{"click":function($event){return _vm.$emit('remove')}}},[_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"loading-bar position-absolute bg-white",style:({
        width: _vm.percentageElapsed + '%'
      })})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{attrs:{"aria-hidden":"true"}},[_c('img',{attrs:{"src":"/images/cross.svg","alt":""}})])
}]

export { render, staticRenderFns }